module.exports = __webpack_public_path__ + "awaiting-arrival-days.png?ff2cb4de687253aea669e006d96e7a1a";